import { ActionReducerMap } from '@ngrx/store';
import { LoggedUserReducers } from './reducers/logged-user.reducers';
import { LoggedUserState } from './states/logged-user.state';
import { StatementsState } from './states/statements.state';
import { StatementReducers } from './reducers/statements.reducers';
import { StatsListReducers } from './reducers/stats-list.reducers';
import { FilterStatsListState } from './states/stats-list.state';
import { FilterReservationState } from './states/filters-reservations.state';
import { ReservationsReducers } from './reducers/filters-reservations.reducers';

export interface AppState {
  LoggedUser: LoggedUserState;
  Statements: StatementsState;
  StatsList: FilterStatsListState;
  FilterReservations: FilterReservationState;
}

export const ROOT_REDUCERS: ActionReducerMap<AppState> = {
  LoggedUser: LoggedUserReducers,
  Statements: StatementReducers,
  StatsList: StatsListReducers,
  FilterReservations: ReservationsReducers,
};
